import {
  fetchWithCache
} from "./chunk.JTCOOS2A.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/mixins/CommonAnimations.ts
var commonAnimationNames = [
  "move_up",
  "move_down",
  "move_left",
  "move_right",
  "scale_increase",
  "scale_decrease",
  "rotate_45_cw",
  "rotate_45_ccw",
  "rotate_360_cw",
  "rotate_360_ccw",
  "rotate_90_cw",
  "rotate_90_ccw",
  "opacity_decrease",
  "opacity_increase",
  "rotate_75_cw"
];
function attachInterestEvents(target, opts = {}) {
  const dispatchFrom = opts.dispatchFrom ?? target;
  const emit = (name) => {
    dispatchFrom.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        composed: true,
        detail: { target }
      })
    );
  };
  const onEnter = () => emit("interest");
  const onLeave = () => emit("loseinterest");
  target.addEventListener("mouseenter", onEnter);
  target.addEventListener("mouseleave", onLeave);
  target.addEventListener("focusin", onEnter);
  target.addEventListener("focusout", onLeave);
  return () => {
    target.removeEventListener("mouseenter", onEnter);
    target.removeEventListener("mouseleave", onLeave);
    target.removeEventListener("focusin", onEnter);
    target.removeEventListener("focusout", onLeave);
  };
}
function CommonAnimations(baseClass) {
  class CommonAnimationsMixin extends baseClass {
    constructor() {
      super(...arguments);
      this.noHover = false;
    }
    connectedCallback() {
      super.connectedCallback();
      this._pathPrefix = document.body.dataset.assetLibrary;
      this._cacheVersion = document.body.dataset.iconCacheVersion;
      this._styleTag = document.createElement("style");
      this.shadowRoot?.prepend(this._styleTag);
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this._styleTag?.remove();
      this._loadedAnimation = "";
    }
    update(changedProperties) {
      super.update(changedProperties);
      if (!changedProperties.has("commonAnimation")) return;
      this._setStyles();
    }
    async _setStyles() {
      if (!this.commonAnimation) {
        this._styleTag.innerHTML = "";
        this._loadedAnimation = "";
        return;
      }
      if (this._loadedAnimation === this.commonAnimation) return;
      try {
        const css = await fetchWithCache(
          `${this._pathPrefix}/commonAnimations/${this.commonAnimation}.css`,
          "Common CSS Animation",
          this._cacheVersion,
          "text/css"
        );
        this._styleTag.innerHTML = css;
        this._loadedAnimation = this.commonAnimation;
      } catch (error) {
        console.error(`Failed to load animation ${this.commonAnimation}:`, error);
      }
    }
  }
  __decorateClass([
    n()
  ], CommonAnimationsMixin.prototype, "commonAnimation", 2);
  __decorateClass([
    n({ type: Boolean, reflect: true })
  ], CommonAnimationsMixin.prototype, "noHover", 2);
  return CommonAnimationsMixin;
}

export {
  commonAnimationNames,
  attachInterestEvents,
  CommonAnimations
};
